import {
    formatDuration,
    intervalToDuration,
    minutesToHours,
    secondsToHours,
    secondsToMinutes,
} from "date-fns";
import { round } from "./value-formatter";

const format = (days, hours, minutes, seconds) =>
    formatDuration({ days, hours, minutes, seconds }, { zero: true });

const TimeSplitter = (value, variant) => {
    if (variant === "chrono") {
        if (value === 0) return "No time spent";
        if (value <= 3600)
            return format(
                undefined,
                undefined,
                secondsToMinutes(value),
                Math.floor(value % 60) || undefined
            );
        if (value > 3600 && value < 86400)
            return format(
                undefined,
                secondsToHours(value),
                Math.floor((value / 60) % 60) || undefined,
                undefined
            );
        if (value >= 86400)
            return format(
                Math.round(secondsToHours(value) / 24),
                Math.floor((value / 3600) % 60) || undefined,
                undefined,
                undefined
            );
    }
    if (variant === "minutes") {
        if (value < 60) return format(undefined, undefined, value, undefined);
        if (value >= 60 && value < 86400)
            return format(
                undefined,
                minutesToHours(value),
                Math.floor(value % 60) || undefined,
                undefined
            );
        if (value >= 86400)
            return format(
                Math.round(minutesToHours(value) / 24),
                Math.floor((value / 60) % 60) || undefined,
                undefined,
                undefined
            );
    }
    if (variant === "text") {
        if (value === 0) return " ";
        const duration = intervalToDuration({ start: 0, end: value * 1000 });
        if (duration.years) {
            return "years";
        }
        if (duration.months) {
            return "months";
        }
        if (duration.days) {
            return "days";
        }
        if (duration.hours) {
            return "hours";
        }
        if (duration.minutes) {
            return "minutes";
        }
        if (duration.seconds) {
            return "seconds";
        }
    }
    if (variant === "plain") {
        if (value === 0) return "-";
        if (value < 60) return `${round(value, 0)}`;
        if (value <= 3600) return `${secondsToMinutes(value)}`;
        if (value > 3600 && value < 86400) return `${secondsToHours(value)}`;
        if (value >= 86400) return `${Math.round(secondsToHours(value) / 24)}`;
    }
    if (variant === "variable-accuracy") {
        let locale = "en-GB";
        try {
            locale = Intl.DateTimeFormat().resolvedOptions().locale;
        } catch (e) {
            //
        }
        const formatter = new Intl.NumberFormat(locale, {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
        });
        if (value === null) return "-";
        if (value === 0) return "0";
        if (value < 60) return `${round(value, 0)}`;
        if (value < 3600) return `${secondsToMinutes(value)}`;
        const duration = intervalToDuration({ start: 0, end: value * 1000 });
        if (duration.years) {
            try {
                return formatter.format((duration.years || 0) + (duration.months || 0) / 12);
            } catch (e) {
                return `${duration.years}`;
            }
        }
        if (duration.months) {
            try {
                return formatter.format((duration.months || 0) + (duration.days || 0) / 30);
            } catch (e) {
                return `${duration.months}`;
            }
        }
        if (duration.days) {
            try {
                return formatter.format((duration.days || 0) + (duration.hours || 0) / 24);
            } catch (e) {
                return `${duration.days}`;
            }
        }
        if (duration.hours) {
            try {
                return formatter.format((duration.hours || 0) + (duration.minutes || 0) / 60);
            } catch (e) {
                return `${duration.hours}`;
            }
        }
    }
    if (variant === "minified") {
        if (value <= 0 && value > -3600) return `${secondsToMinutes(value)} m`;
        if (value <= -3600 && value > -86400) return `${secondsToHours(value)} m`;
        if (value <= -86400) return `${Math.round(secondsToHours(value) / 24)} d`;
        if (value <= 3600) return `${secondsToMinutes(value)} m`;
        if (value > 3600 && value < 86400) return `${secondsToHours(value)} h`;
        if (value >= 86400) return `${Math.round(secondsToHours(value) / 24)} d`;
    }
    if (variant === "stage-duration") {
        if (value === 0) return "No time";
        if (value < 60) return `${round(value, 0)} sec`;
        if (value <= 3600) return `${secondsToMinutes(value)} min`;
        if (value > 3600 && value < 86400) return `${secondsToHours(value)} hrs`;
        if (value >= 86400) return `${Math.round(secondsToHours(value) / 24)} days`;
    }
    if (variant === "tickets") {
        if (value === 0 || value === null) return "No time";
        if (value < 60) return `${round(value, 0)} s`;
        if (value <= 3600) return `${secondsToMinutes(value)} m`;
        if (value > 3600 && value < 86400) return `${secondsToHours(value)} h`;
        if (value >= 86400) return `${Math.round(secondsToHours(value) / 24)} d`;
    }
    if (variant === "wellbeing-heatmap") {
        if (value === 0) return "No time";
        if (value < 60) return `${round(value, 0)} sec`;
        if (value <= 3600) return `${secondsToMinutes(value)} min`;
        if (value > 3600 && value < 86400) return `${secondsToHours(value)} hrs`;
        if (value >= 86400) return `${Math.round(secondsToHours(value) / 24)} days`;
    }
    if (variant === "seconds") {
        if (value === 0) return "none";
        if (value <= 60) return format(undefined, undefined, undefined, value);
        if (value <= 3600)
            return format(
                undefined,
                undefined,
                secondsToMinutes(value),
                Math.floor(value % 60) || undefined
            );
        if (value > 3600 && value < 86400)
            return format(
                undefined,
                secondsToHours(value),
                Math.floor((value / 60) % 60) || undefined,
                undefined
            );
        if (value >= 86400)
            return format(
                Math.round(secondsToHours(value) / 24),
                Math.floor((value / 3600) % 60) || undefined,
                undefined,
                undefined
            );
    }
    return null;
};

export default TimeSplitter;
